import React from "react";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAbout from "../../components/about/FormAbout";
import { useGetAbout } from "../../hooks/about/useGetAbout";
import { useUpdateAbout } from "../../hooks/about/useUpdateAbout";

const About = () => {
    const { about, isLoading: isFetching } = useGetAbout();
    const { mutate, isPending: isUpdating } = useUpdateAbout();

    const handleSubmit = (data) => {
        mutate(data);
    };

    if (isFetching) {
        return null;
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAbout
                titleAr="من نحن"
                titleEn="About Us"
                currentData={about}
                onSubmit={handleSubmit}
                isLoading={isUpdating}
            />
        </WrapperSection>
    );
};

export default About;
